import * as yup from 'yup';
import {
  emailSchema,
  requiredErrorMessage,
  strongPasswordSchema,
} from '@common/schema';

export const registerSchema = yup.object().shape({
  email: emailSchema.required(requiredErrorMessage),
  password: strongPasswordSchema,
  confirm: yup.string().oneOf([yup.ref('password')], 'Passwords must match'),
});
